module.exports = __webpack_public_path__ + "img/file-type-zip-alt.f61916b7.svg";